import { Component } from '@angular/core';

/**
 * Unknown routes on release hosts. The CDN already answers these URLs with a
 * real HTTP 404 (edge function); this is what a visitor sees, and what an
 * in-app navigation to a withdrawn route shows.
 */
@Component({
  selector: 'pla-not-found',
  template: `
    <div class="page">
      <div class="content-container px-3">
        <div class="center-content-container not-found">
          <h1>Page not found</h1>
          <p>We couldn't find that page. It may have moved, or the address may be mistyped.</p>
          <div class="not-found-links">
            <a routerLink="/">Search plates</a>
            <a routerLink="/plate-viewer">PlateViewer</a>
            <a routerLink="/plates/current-style">New releases</a>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [
    `.not-found { padding: 64px 0; text-align: center; }
     .not-found h1 { font-size: 28px; font-weight: 700; margin-bottom: 12px; }
     .not-found p { color: #555; margin-bottom: 24px; }
     .not-found-links { display: flex; gap: 16px; justify-content: center; flex-wrap: wrap; }
     .not-found-links a { font-weight: 600; }`,
  ],
})
export class NotFoundComponent {}
